/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { WorkPackageStatuses } from '../../constants/storyStatusTypes';
import { updateAllAttributesWorkPackageStatus } from '../../actions/workPackageActions';
import { initialsGenerator } from '../../utils/string';

class ResultDetailsStatus extends React.Component {
  state = {
    browserWidth: 0
  }


  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
    this.updateDimensions()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({ browserWidth: window.innerWidth });
  };

  handleClick = event => {
    event.preventDefault();
    const { updateWorkPackageStatus, result } = this.props;
    if (result.id) {
      const updatedWorkPackage = JSON.parse(JSON.stringify(result));
      updatedWorkPackage.state = event.target.name;
      updateWorkPackageStatus(result, updatedWorkPackage, event.target.name);
    } else {
      this.props.handleFieldChange({ state: event.target.name });
    }
  };

  render() {
    const { status, blockStatus } = this.props;
    const { browserWidth } = this.state;
    const disabled = !this.props.allowEdit;
    return (
      <div className="row">
        <div className="col-sm-3">
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.NOT_READY}
              className={`status-btn ${blockStatus && 'disabled'} ${
                status === WorkPackageStatuses.NOT_READY
                  ? 'not-ready-active'
                  : 'not-ready-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled || blockStatus}
            >
              {browserWidth < 1072 ? initialsGenerator("NOT READY") : "NOT READY"}
            </button>
          </div>
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.GETTING_READY}
              className={`status-btn ${blockStatus && 'disabled'} ${
                status === WorkPackageStatuses.GETTING_READY
                  ? 'getting-ready-active'
                  : 'getting-ready-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled || blockStatus}
            >
            {browserWidth < 1072 ? initialsGenerator("GETTING READY") : "GETTING READY"}
            </button>
          </div>
        </div>
        <div className="col-sm-3">
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.READY}
              className={`status-btn ${blockStatus && 'disabled'} ${
                status === WorkPackageStatuses.READY
                  ? 'ready-active'
                  : 'ready-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled || blockStatus}
            >
              READY
            </button>
          </div>
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.IN_PROGRESS}
              className={`status-btn ${
                status === WorkPackageStatuses.IN_PROGRESS
                  ? 'progress-active'
                  : 'progress-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled}
            >
              {browserWidth < 1072 ? initialsGenerator("IN PROGRESS") : "IN PROGRESS"}
            </button>
          </div>
        </div>
        <div className="col-sm-3">
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.COMPLETED}
              className={`status-btn ${
                status === WorkPackageStatuses.COMPLETED ||
                status === 'Complete'
                  ? 'complete-active'
                  : 'complete-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled}
            >
            {browserWidth < 1072 ? initialsGenerator("DEV COMPLETE") : "DEV COMPLETE"}
            </button>
          </div>
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.ACCEPTED}
              className={`status-btn ${
                status === WorkPackageStatuses.ACCEPTED
                  ? 'accepted-active'
                  : 'accepted-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled}
            >
              ACCEPTED
            </button>
          </div>
        </div>
        <div className="col-sm-3">
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.SHIPPABLE}
              className={`status-btn ${
                status === WorkPackageStatuses.SHIPPABLE
                  ? 'shippable-active'
                  : 'shippable-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled}
            >
              SHIPPABLE
            </button>
          </div>
          <div className="col-sm-6">
            <button
              type="button"
              name={WorkPackageStatuses.LIVE}
              className={`status-btn ${
                status === WorkPackageStatuses.LIVE
                  ? 'live-active'
                  : 'live-normal'
              }`}
              onClick={this.handleClick}
              disabled={disabled}
            >
              LIVE
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ResultDetailsStatus.propTypes = {
  result: PropTypes.object,
  status: PropTypes.string,
  allowEdit: PropTypes.bool,
  handleFieldChange: PropTypes.func
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateWorkPackageStatus: updateAllAttributesWorkPackageStatus
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(ResultDetailsStatus);
